module.exports = __webpack_public_path__ + "img/1513760938.f0e215c4.jpg";